import { h, Component, Fragment } from 'preact';
import ProductsAPI from '../api/ProductsAPI';
import TableAPI from '../api/TableAPI';
import Posts from '../components/Posts';
import Filter from './Filter';
import Loader from '../components/Loader';
import Pagination from '../components/Pagination'
import { clearAllBodyScrollLocks } from 'body-scroll-lock';

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      posts: [],
      allPosts: [],
      currentCategories: [],
      currentWidths: [],
      currentColors: [],
      allCategories: [],
      allWidths: [],
      allColors: [],
      count: 15,
      offset: 0,
      currentPage: 1,
      order: '',
      showAll: false,
    };
  }

  componentDidMount() {
    // Pagination
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const currentPage = urlParams.get('current_page')

    if (currentPage) {
      this.setState(
        {
          posts: [],
          allPosts: [],
          currentPage: Number(currentPage),
          offset: this.state.count * Number(currentPage) - this.state.count
        },
        this.initiate
      )
    } else {
      this.initiate()
    }
  }

  initiate() {
    this.fetchProducts();
    this.fetchAllPosts();
  }

  fetchProducts() {
    this.setState({ isLoading: true })

    ProductsAPI.all(this.state)
    .then(response => {
      return response.json()
    })
    .then(data => {
      this.setState({
        posts: [...this.state.posts, ...data],
        isLoading: false
      })
    }).catch(error => {
      this.setState({
        fetchError: true,
        isLoading: false
      })
      throw Error(`Fetching products failed: ${error}`)
    })
  }

  fetchAllPosts() {
    this.setState({ isLoading: true })

    TableAPI.all(this.state)
    .then(response => {
      return response.json()
    })
    .then(data => {
      this.setState({
        allPosts: [...this.state.allPosts, ...data],
        isLoading: false
      }),
      this.fetchCategories(),
      this.fetchThickness(),
      this.fetchColors()
    }).catch(error => {
      this.setState({
        fetchError: true,
        isLoading: false
      })
      throw Error(`Fetching products failed: ${error}`)
    })
  }

  fetchCategories() {
    let allCategoriesArray = [...this.state.allCategories];
    
    this.state.allPosts.map((post) => {
      (allCategoriesArray.includes(post.product_shape) || post.product_shape < 1) 
      ? null
      : allCategoriesArray.push(post.product_shape);
    })

    this.setState(() => {
      return {
        allCategories: allCategoriesArray
      };
    });
  }

  fetchThickness() {
    let allWidthsArray = [...this.state.allWidths];
    
    this.state.allPosts.map((post) => {
      (allWidthsArray.includes(post.product_thickness) || post.product_thickness < 1) 
      ? null
      : allWidthsArray.push(post.product_thickness);
    })

    this.setState(() => {
      return {
        allWidths: allWidthsArray
      };
    });
  }

  fetchColors() {
    let allColorsArray = [...this.state.allColors];
    
    this.state.allPosts.map((post) => {
      (allColorsArray.includes(post.product_color) || post.product_color.length < 1) 
        ? null
        : allColorsArray.push(post.product_color);
    })

    this.setState(() => {
      return {
        allColors: allColorsArray
      };
    });
  }

  handleChange(e) {
    let currentElements = [...this.state[e.currentTarget.dataset.target]];

    (currentElements.includes(e.currentTarget.dataset.id)) 
      ? currentElements = currentElements.filter(item => item !== e.currentTarget.dataset.id)
      : currentElements.push(e.currentTarget.dataset.id);

    this.setState(() => {
      return {
        [e.currentTarget.dataset.target]: currentElements,
        posts: [],
        allPosts: [],
        offset: 0,
      };
    }, this.initiate);
  }

  handleRemove(e) {
    let currentElements = [...this.state[e.currentTarget.dataset.target]];
    currentElements = currentElements.filter(item => item !== e.currentTarget.dataset.id);

    this.setState(() => {
      return {
        [e.currentTarget.dataset.target]: currentElements,
        posts: [],
        allPosts: [],
        offset: 0,
      };
    }, this.initiate);
  }

  handleReset() {
    this.setState(() => {
      return {
        posts: [],
        allPosts: [],
        allCategories: [],
        allWidths: [],
        allColors: [],
        currentCategories: [],
        currentWidths: [],
        currentColors: [],
      };
    }, this.initiate);
  }

  handleToggle() {
    if (this.state.filterActive) {
      clearAllBodyScrollLocks();
    }
    this.setState({ filterActive: !this.state.filterActive });
  }

  updateURL(page) {
    // Update URL so page is set on refresh
    if (history.pushState) {
      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        `?current_page=${page}`
      window.history.pushState({ path: newurl }, '', newurl)
    }
  }

  handlePageClick(e) {
    // Multiply the count by the currentPage to get the correct offset
    if (e.currentTarget.dataset.page) {
      window.scrollTo(0, 0)
      this.updateURL(e.currentTarget.dataset.page)
      this.setState(
        {
          posts: [],
          allPosts: [],
          currentPage: Number(e.currentTarget.dataset.page),
          offset: this.state.count * Number(e.currentTarget.dataset.page) - this.state.count
        },
        this.initiate
      )
    }
  }

  handleOrderChoice(order) {
    this.setState(
      {
        order: order.currentTarget.dataset.id,
        posts: [],
        allPosts: [],
        offset: 0
      },
      this.fetchProducts
    )
  }

  render() {
    return (
      <div className="c-shop-overview__app-container">
        <div className="c-shop-overview__filter-top-bar u-flex u-flex-sb">
          <div class="c-shop-overview__count">
            {this.state.allPosts.length} resultaten
          </div>

          <div className="c-shop-overview__filter-button" onClick={this.handleToggle.bind(this)}>
            Filteren

            {this.state.filterActive ? (
              <svg className="c-icon c-shop-overview__filter-icon active">
                <use href="#close" xlinkHref="#close" />
              </svg>
            ) : (
              <svg className="c-icon c-shop-overview__filter-icon">
                <use href="#filter" xlinkHref="#filter" />
              </svg>
            )}
          </div>
        </div>
        <div class="c-shop-overview__filter-container">
          <Filter
            posts={this.state.posts}
            allPosts={this.state.allPosts}
            allCategories={this.state.allCategories}
            allWidths={this.state.allWidths}
            allColors={this.state.allColors}
            currentCategories={this.state.currentCategories}
            currentWidths={this.state.currentWidths}
            currentColors={this.state.currentColors}
            order={this.state.order}
            handleChange={this.handleChange.bind(this)}
            filterActive={this.state.filterActive}
            handleToggle={this.handleToggle.bind(this)}
            isLoading={this.state.isLoading}
            handleRemove={this.handleRemove.bind(this)}
            handleReset={this.handleReset.bind(this)}
            handleOrder={this.handleOrderChoice.bind(this)}
          />
        </div>
        {this.state.isLoading ? (
          <Loader />
        ) : (
          <div class="c-shop-overview__posts-wrapper">
            {this.state.posts.length > 0 ? (
              <div class="c-shop-overview__fragment-wrapper">
                <div class="c-shop-overview__posts-container">
                  <Posts
                    posts={this.state.posts}
                    allPosts={this.state.allPosts}
                    loading={this.state.isLoading}
                    handleOrderChoice={this.handleOrderChoice.bind(this)}
                  />

                  <Pagination
                    count={this.state.count}
                    offset={this.state.offset}
                    currentPage={this.state.currentPage}
                    totalAmountPosts={this.state.allPosts.length}
                    handlePageClick={this.handlePageClick.bind(this)}
                  />
                </div>
              </div>
            ) : (
              <div className="c-shop-overview__no-posts">
                Geen resultaten
                <div className="c-shop-overview__reset" onClick={() => { this.handleReset(); }} >
                  Reset filters
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/js/shop-overview/containers/App.js